import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Calendar, ArrowRight } from 'lucide-react';

const CALENDAR_URL = '#';

export default function CTAStrip({ variant = 'default' }) {
  const { t } = useLanguage();

  if (variant === 'bold') {
    return (
      <div data-testid="cta-strip-bold" className="relative py-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A4D75]/40 via-[#0B1E2E] to-[#1A4D75]/40" />
        <div className="absolute inset-0 border-y border-[#42D2D9]/10" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {t('cta_strip.bold_title')}
            </h3>
            <p className="text-sm text-slate-400">{t('cta_strip.bold_subtitle')}</p>
          </div>
          <a
            href={CALENDAR_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-strip-bold-btn"
            className="cta-primary inline-flex items-center gap-3 whitespace-nowrap shrink-0"
          >
            <Calendar className="w-4 h-4 relative z-10" strokeWidth={1.5} />
            <span>{t('cta_strip.cta')}</span>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="cta-strip-default" className="relative py-10">
      <div className="absolute inset-0 bg-[#0B1E2E]" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row items-center justify-center gap-4">
        <p className="text-sm text-slate-400">{t('cta_strip.default_text')}</p>
        <a
          href={CALENDAR_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-strip-default-btn"
          className="inline-flex items-center gap-2 text-sm text-[#42D2D9] hover:text-white transition-colors font-semibold"
        >
          {t('cta_strip.cta')}
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
